import { Component, OnInit } from '@angular/core';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';
import { DataAlertProgresBarStatus } from '../../../interfaces/dash-alerts-interfaces';

@Component({
  selector: 'alert-status-percentage',
  templateUrl: './alert-status-percentage.component.html',
  styleUrls: ['./alert-status-percentage.component.scss'],
})
export class AlertStatusPercentageComponent implements OnInit {
  constructor(private resumeService: ResumeService) {}
  barsDataStatus: DataAlertProgresBarStatus[];
  total: number;
  ngOnInit() {
    this.getDataBarStatusAlert();
  }
  async getDataBarStatusAlert() {
    await this.resumeService.getDataBarStatusAlert().subscribe((res: any) => {
      this.barsDataStatus = res.caseInfo;
      this.total = res.total;
    });
  }
}
